import { render, staticRenderFns } from "./ClientProfileCreditHistory.vue?vue&type=template&id=81eaf738&scoped=true&"
import script from "./ClientProfileCreditHistory.vue?vue&type=script&lang=js&"
export * from "./ClientProfileCreditHistory.vue?vue&type=script&lang=js&"
import style0 from "./ClientProfileCreditHistory.vue?vue&type=style&index=0&id=81eaf738&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81eaf738",
  null
  
)

export default component.exports